import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/proxima_nova/proxima-nova.css";
import "quill/dist/quill.snow.css";
import { pdfjs } from "react-pdf";
if (
  ["FAF-nt", "nrdata-orig"].includes(process.env.REACT_APP_STYLING_THEME ?? "")
) {
  import("styles/nrdata.css");
} else {
  import("styles/combase.css");
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
